import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import { t } from '../../../../modules/infra/i18n';
import Money from '../../../common/money';

const SubscriptionDetails = ({ subscription }) => (
  <div>
    <div>
      {t('subscription:active_plan_label')} { subscription ? subscription.subscriptionPlan.name : t('subscription:no_active_plan_label') }
    </div>
    <div display-if={subscription}>{t('subscription:email_label')} {subscription.email}</div>
    <div>{t('subscription:status_label')} { subscription ? startCase(subscription.status) : t('subscription:no_status_info_label') }</div>
    <div display-if={subscription}>
      <div>{t('subscription:price_label')} <Money currency={subscription.currency}>
        {subscription.priceWithoutDiscount}
      </Money></div>
      <div display-if={subscription.coupon}>
        <div>
          {t('subscription:discount_label')}&nbsp;
          <Money currency={subscription.currency}>
            {subscription.discountAmount}
          </Money>
        </div>
        <div>{t('subscription:total_label')} <Money currency={subscription.currency}>{subscription.price}</Money></div>
      </div>
    </div>
  </div>
);

SubscriptionDetails.propTypes = {
  subscription: PropTypes.object,
};

SubscriptionDetails.defaultProps = {
  subscription: null,
};

export default SubscriptionDetails;

